module.exports = __webpack_public_path__ + "static/sm_img02_m@2x-e6773b63aa55c10ee8ea6bc2f63467ab.jpg";